import api from '@/utils/axios';
import { unwrapItem, unwrapList } from '@/utils/apiHelpers';
import type { ApiDocument, DocumentValidationStatus } from './types';

export interface DocumentWritePayload {
  category_id: number;
  user_id: number;
  file_url: string;
  started_at: string;
  ended_at: string;
}

export async function listDocuments(): Promise<ApiDocument[]> {
  const res = await api.get('/documents');
  return unwrapList<ApiDocument>(res.data);
}

export async function getDocument(documentId: number): Promise<ApiDocument> {
  const res = await api.get(`/documents/${documentId}`);
  return unwrapItem<ApiDocument>(res.data);
}

export async function createDocument(payload: DocumentWritePayload): Promise<ApiDocument> {
  const res = await api.post('/documents', payload);
  return unwrapItem<ApiDocument>(res.data);
}

export async function updateDocument(documentId: number, payload: Partial<DocumentWritePayload>): Promise<ApiDocument> {
  const res = await api.patch(`/documents/${documentId}`, payload);
  return unwrapItem<ApiDocument>(res.data);
}

export async function deleteDocument(documentId: number): Promise<void> {
  await api.delete(`/documents/${documentId}`);
}

export async function validateDocument(documentId: number, status: DocumentValidationStatus): Promise<ApiDocument> {
  const res = await api.patch(`/documents/${documentId}/validate`, { status });
  return unwrapItem<ApiDocument>(res.data);
}

export async function listUserDocuments(userId: number): Promise<ApiDocument[]> {
  const res = await api.get(`/users/${userId}/documents`);
  return unwrapList<ApiDocument>(res.data);
}

export async function storeUserDocuments(
  userId: number,
  documents: Omit<DocumentWritePayload, 'user_id'>[],
): Promise<ApiDocument[]> {
  const res = await api.post(`/users/${userId}/documents`, { documents });
  return unwrapList<ApiDocument>(res.data);
}

export async function downloadDocumentBlob(documentId: number): Promise<{ blob: Blob }> {
  const res = await api.get(`/documents/${documentId}/download`, {
    responseType: 'blob',
  });
  return { blob: res.data };
}
